(function () {
  function blank(node) {
    if (node.nodeType === 3) return !node.textContent.trim();
    if (node.nodeType !== 1) return true;
    if (node.tagName === 'BR') return true;
    return !node.textContent.trim() && !node.querySelector('img,svg,video,iframe,picture,hr');
  }
  function trimEdges(container) {
    ['firstChild', 'lastChild'].forEach(function (edge) {
      var node = container[edge];
      while (node && blank(node)) {
        container.removeChild(node);
        node = container[edge];
      }
      if (node && node.nodeType === 1 && node.tagName !== 'UL' && node.tagName !== 'OL' && node.children.length) trimEdges(node);
      if (node && node.nodeType === 3) node.textContent = edge === 'firstChild' ? node.textContent.replace(/^\s+/, '') : node.textContent.replace(/\s+$/, '');
    });
  }
  function tidy(scope) {
    scope.querySelectorAll('[data-fp-faq] details').forEach(function (item) {
      var answer = item.querySelector(':scope > div');
      if (answer && !answer.hasAttribute('data-fp-faq-trimmed')) {
        trimEdges(answer);
        answer.setAttribute('data-fp-faq-trimmed', '');
      }
      var title = item.querySelector(':scope > summary');
      if (title) title.textContent = title.textContent.trim();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { tidy(document); });
  else tidy(document);
})();

document.addEventListener('input', function (event) {
  if (!event.target.matches('[data-fp-faq-search]')) return;
  var container = event.target.closest('[data-fp-faq]');
  var query = event.target.value.trim().toLowerCase();
  var count = 0;
  container.querySelectorAll('details').forEach(function (item) {
    item.hidden = !item.textContent.toLowerCase().includes(query);
    if (!item.hidden) count++;
  });
  container.querySelector('[data-fp-faq-empty]').hidden = count !== 0;
});
